import { render } from "./FormListScreen.vue?vue&type=template&id=382aa810&scoped=true"
import script from "./FormListScreen.vue?vue&type=script&lang=js"
export * from "./FormListScreen.vue?vue&type=script&lang=js"

import "./FormListScreen.vue?vue&type=style&index=0&id=382aa810&scoped=true&style=scss&lang=css"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382aa810"]])

export default __exports__